import { css } from '@emotion/react'
import { theme } from '../../../styles/theme'
import { EmptyDataProps } from './EmptyData'

export const containerStyles = (borderColor?: EmptyDataProps['borderColor']) => () => css`
  border: 1px dashed ${borderColor ? theme.palette[borderColor].main : theme.palette.primary.main};
  border-radius: 12px;
  padding: 48px 32px;
  text-align: center;
  margin: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-grow: 1;
`

export const iconWrapperStyles = css`
  background: #f7f7f7;
  padding: 12px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const titleStyles = css`
  color: ${theme.palette.text.primary};
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
`

export const descriptionStyles = css`
  font-size: 0.9rem;
  color: ${theme.palette.text.secondary};
  margin: 0;
  max-width: 280px;
`
